var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"hero-icon",class:'hero-icon--' + _vm.name,style:({ width: _vm.size, height: _vm.size }),attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke-width":"1.5","stroke":"currentColor","aria-hidden":"true"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":_vm.path}})])
}
var staticRenderFns = []

export { render, staticRenderFns }